<template>
  <span class="data-value">
    <slot></slot>
  </span>
</template>

<style scoped lang="scss">
.data-value {
  font-size: var(--font-size-subtitle-2);
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  max-width: 100%;
}
</style>
